import { useDispatch, useSelector } from 'react-redux';
import { useEffectOnce } from 'usehooks-ts';

import { useParseParams } from '@hooks/params';
import { findPersonalAccidentQuoteParamsSchema } from '@apis/PersonalAccidentQuoteApi';

import { selectPersonalAccidentQuoteDetailsPage } from './selector';
import { personalAccidentQuoteFind, PersonalAccidentQuoteFindPayload } from './action';
import { PersonalAccidentQuoteDetailsPageParams } from './route';

export const usePersonalAccidentQuoteDetailsPageParams = () =>
  useParseParams<PersonalAccidentQuoteDetailsPageParams>(findPersonalAccidentQuoteParamsSchema);

export const usePersonalAccidentQuoteFind = () => {
  const dispatch = useDispatch();
  const params = usePersonalAccidentQuoteDetailsPageParams();
  const { personalAccidentQuote } = useSelector(selectPersonalAccidentQuoteDetailsPage);

  useEffectOnce(() => {
    const payload: PersonalAccidentQuoteFindPayload = params;
    dispatch(personalAccidentQuoteFind(payload));
  });

  return personalAccidentQuote;
};
